import {
    IAppClosedTopicPayload, IAppInitFailedTopicPayload, IAppInitSucceededTopicPayload,
    IDivHostedAppInitParameters, IOpenAppData,
    IZoidHostedAppInitParameters
} from "@sparkware/uc-sdk-core";
import {ICasinofiedApplicationAdapter} from "./casinofied-application-adapter.interface";

export class CasinofiedZoidApplicationAdapter implements ICasinofiedApplicationAdapter {
    constructor(protected readonly appID: string, protected readonly applicationSdk: any) {
    }

    init(initParams: IDivHostedAppInitParameters) {
        const clonedInitParams = {...initParams};
        delete clonedInitParams.messageBrokerChannels

        const zoidInitParams: IZoidHostedAppInitParameters = {
            ...clonedInitParams,
            onInitSucceeded: (payload) => this._onInitSucceeded(payload, initParams),
            onInitFailed: (payload) => this._onInitFailed(payload, initParams),
            openApp: payload => this._openApp(payload, initParams),
            onClose: (payload) => this._onClose(payload, initParams)
        }

        this.applicationSdk.init(zoidInitParams);
    }

    focus() {
        if(this.applicationSdk.focus) {
            this.applicationSdk.focus(this.appID);
        }
    }

    protected _openApp(payload: IOpenAppData, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.navigation.topics.openApp.publish({
                                                                               publisher: this.appID
                                                                           }, payload);
    }
    protected _onInitSucceeded(payload: IAppInitSucceededTopicPayload, initParams: IDivHostedAppInitParameters){
        initParams.messageBrokerChannels.session.topics.appInitSucceeded.publish({
            publisher: this.appID
        }, payload);
    }
    protected _onInitFailed (payload: IAppInitFailedTopicPayload, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.session.topics.appInitFailed.publish({
            publisher: this.appID
        }, payload)
    }
    protected _onClose(payload: IAppClosedTopicPayload, initParams: IDivHostedAppInitParameters) {
        initParams.messageBrokerChannels.session.topics.appClosed.publish({
            publisher: this.appID
        }, payload);
    }
}